/* eslint react/forbid-prop-types: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import {
  Row,
  Col,
  Table,
  Jumbotron,
  ButtonGroup,
  Button,
  Glyphicon
} from "react-bootstrap";
import {
  getRunsheets,
  allocateRunsheet,
  updateVehicle,
  removeVehicle,
  cancelRunsheet
} from "../../../actions/runsheets";
import RunsheetTableItem from "./RunsheetTableItem";
import Loading from "../../Loading";
import TableDatePicker from "./TableDatePicker";
import CalendarFilters from "./CalendarFilters";
import updateFilters from "../../../actions/filters";
import SortableHeader from "./SortableHeader";
import Footer from "./Footer";
import updateDate from "../../../actions/date";
import RunsheetUpload from "./RunsheetUpload";

class RunsheetTable extends Component {
  state = {
    fetched: false,
    error: false,
    pagination: {
      sort: "id",
      direction: "desc",
      pageSize: 25,
      page: 1
    },
    display: "TABLE"
  };

  componentDidMount() {
    const { date, filters } = this.props;
    const { pagination: { page, pageSize, sort, direction } } = this.state;
    const momentDate = moment(date);
    const fromDate = this.startOfDay(momentDate).toISOString();
    const toDate = this.endOfDay(momentDate).toISOString();
    const query = {
      fromDate,
      toDate,
      page,
      pageSize,
      sort,
      direction,
      ...filters
    };
    this.props.getRunsheets(query)
      .then(() => this.setState({ fetched: true }))
      .catch(() => this.setState({ error: true }));
  }

  handlePageChange = page => {
    const { date, filters } = this.props;
    const pagination = { ...this.state.pagination, page };
    const momentDate = moment(date);
    this.setState({ pagination });
    this.props.updateFilters(filters);
    const fromDate = this.startOfDay(momentDate).toISOString();
    const toDate = this.endOfDay(momentDate).toISOString();
    const query = {
      fromDate,
      toDate,
      ...pagination,
      ...filters
    };
    this.props.getRunsheets(query).then(() => this.setState({ fetched: true }));
  };

  handlePerPageChange = value => {
    const { date, filters } = this.props;
    const pagination = { ...this.state.pagination, pageSize: value, page: 1 };
    const momentDate = moment(date);
    this.setState({ pagination });
    this.props.updateFilters(filters);
    const fromDate = this.startOfDay(momentDate).toISOString();
    const toDate = this.endOfDay(momentDate).toISOString();
    const query = {
      fromDate,
      toDate,
      ...pagination,
      ...filters
    };
    this.props.getRunsheets(query).then(() => this.setState({ fetched: true }));
  };

  handleSort = ({ sort, direction }) => {
    const { date, filters } = this.props;
    const pagination = { ...this.state.pagination, sort, direction };
    const momentDate = moment(date);
    this.setState({ pagination });
    this.props.updateFilters(filters);
    const fromDate = this.startOfDay(momentDate).toISOString();
    const toDate = this.endOfDay(momentDate).toISOString();
    const query = {
      fromDate,
      toDate,
      ...pagination,
      ...filters
    };
    this.props.getRunsheets(query).then(() => this.setState({ fetched: true }));
  };

  handleDateChange = date => {
    const pagination = { ...this.state.pagination, page: 1 };
    this.props.updateDate(date.toISOString());
    this.setState({ pagination, fetched: false });
    const fromDate = this.startOfDay(date).toISOString();
    const toDate = this.endOfDay(date).toISOString();
    const { page, pageSize, sort, direction } = pagination;
    const query = {
      fromDate,
      toDate,
      page,
      pageSize,
      sort,
      direction,
      ...this.props.filters
    };
    this.props.getRunsheets(query).then(() => this.setState({ fetched: true }));
  };

  startOfDay = date => date.clone().startOf("day");
  endOfDay = date => date.clone().endOf("day");

  handleFilterChange = filters => {
    const { date } = this.props;
    const { pagination: { page, pageSize, sort, direction } } = this.state;
    const momentDate = moment(date);
    this.props.updateFilters(filters);
    const fromDate = this.startOfDay(momentDate).toISOString();
    const toDate = this.endOfDay(momentDate).toISOString();
    const query = {
      fromDate,
      toDate,
      page,
      pageSize,
      sort,
      direction,
      ...filters
    };
    this.props.getRunsheets(query).then(() => this.setState({ fetched: true }));
  };

  render() {
    const { date, runsheets, path, total } = this.props;
    const { pagination: { page, pageSize, sort, direction } } = this.state;
    const momentDate = moment(date);

    const runsheetItems = runsheets.map(runsheet => (
      <RunsheetTableItem
        key={runsheet.id}
        runsheet={runsheet}
        matchPath={path}
        allocateRunsheet={this.props.allocateRunsheet}
        updateVehicle={this.props.updateVehicle}
        removeVehicle={this.props.removeVehicle}
        cancelRunsheet={this.props.cancelRunsheet}
      />
    ));

    if (runsheetItems.length === 0) {
      runsheetItems.push(
        <tr key="0">
          <td colSpan="7">
            <Jumbotron>
              <p style={{ textAlign: "center" }}>No Runsheets found</p>
            </Jumbotron>
          </td>
        </tr>
      );
    }

    if (this.state.error) {
      return <p>Error retrieving runsheets</p>;
    }

    return (
      <div>
        <Row>
          <Col xs={12}>
            <div className="table-filters-wrapper">
              <div className="table-date-picker">
                <TableDatePicker
                  date={momentDate}
                  onChange={this.handleDateChange}
                />
              </div>
              <CalendarFilters
                filters={this.props.filters}
                onChange={this.handleFilterChange}
              />
              <ButtonGroup className="align-top">
                <Button bsStyle="primary" title="Table View">
                  <Glyphicon glyph="th-list" />
                </Button>
                <Button
                  title="Calendar View"
                  onClick={() => this.props.handleDisplayChange("CALENDAR")}
                >
                  <Glyphicon glyph="calendar" />
                </Button>
              </ButtonGroup>{" "}
              <div className="knowledgebase-container">
                <a
                  title="Task Manager Guide"
                  href="https://transtech.atlassian.net/wiki/x/EgCZEg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="sprite-image icon_knowledgebase" />
                </a>
              </div>
              <div className="pull-right">
                <div className="display-inline align-top">
                  <Button
                    href="/runsheets/new"
                    className="btn btn-default"
                    title="Add New Runsheet"
                  >
                    <Glyphicon glyph="plus" /> Add New Runsheet
                  </Button>
                </div>{" "}
                <div className="display-inline align-top">
                  <RunsheetUpload />
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {this.state.fetched ? (
          <Row>
            <Col xs={12}>
              <Table striped bordered className="runsheets-table">
                <thead>
                  <tr>
                    <th className="progress-table-header">Progress</th>
                    <SortableHeader
                      value="id"
                      sort={sort}
                      direction={direction}
                      handleSort={this.handleSort}
                    >
                      ID
                    </SortableHeader>
                    <th className="runsheets-table-head">Name</th>
                    <SortableHeader
                      value="vehicleName"
                      sort={sort}
                      direction={direction}
                      handleSort={this.handleSort}
                    >
                      Vehicle
                    </SortableHeader>
                    <SortableHeader
                      value="userName"
                      sort={sort}
                      direction={direction}
                      handleSort={this.handleSort}
                    >
                      Driver
                    </SortableHeader>
                    <SortableHeader
                      value="scheduledAt"
                      sort={sort}
                      direction={direction}
                      handleSort={this.handleSort}
                    >
                      Scheduled At
                    </SortableHeader>
                    <th className="actions-table-header">Actions</th>
                  </tr>
                </thead>
                <tbody>{runsheetItems}</tbody>
              </Table>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col xs={12}>
              <Loading />
            </Col>
          </Row>
        )}

        <Row>
          <Col xs={12}>
            <Footer
              page={page}
              pageSize={pageSize}
              totalRunsheets={total}
              handlePageChange={this.handlePageChange}
              handlePerPageChange={this.handlePerPageChange}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
RunsheetTable.propTypes = {
  getRunsheets: PropTypes.func.isRequired,
  runsheets: PropTypes.array.isRequired,
  path: PropTypes.string.isRequired,
  handleDisplayChange: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  filters: PropTypes.object.isRequired,
  updateFilters: PropTypes.func.isRequired,
  date: PropTypes.string.isRequired,
  updateDate: PropTypes.func.isRequired,
  cancelRunsheet: PropTypes.func.isRequired,
  allocateRunsheet: PropTypes.func.isRequired,
  updateVehicle: PropTypes.func.isRequired,
  removeVehicle: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  runsheets: state.runsheets.paginate.runsheets,
  total: state.runsheets.paginate.total,
  filters: state.filters,
  date: state.date
});

const mapDispatchToProps = {
  getRunsheets,
  updateFilters,
  updateDate,
  allocateRunsheet,
  updateVehicle,
  removeVehicle,
  cancelRunsheet
};

export default connect(mapStateToProps, mapDispatchToProps)(RunsheetTable);



// WEBPACK FOOTER //
// ./src/components/runsheets/list/RunsheetTable.js